import { DayOfWeek, FulfillmentType, Platform, DishOptionType, } from '@wix/ambassador-restaurants-catalogs-v3-catalog/types';
export { Platform as CatalogPlatform, FulfillmentType, DayOfWeek, DishOptionType, };
export var days = [
    DayOfWeek.UNDEFINED,
    DayOfWeek.MON,
    DayOfWeek.TUE,
    DayOfWeek.WED,
    DayOfWeek.THU,
    DayOfWeek.FRI,
    DayOfWeek.SAT,
    DayOfWeek.SUN,
];
export var daysOfWeekAsWeekday = {
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
    SUN: 7,
};
//# sourceMappingURL=Catalog.js.map